module.exports = __webpack_public_path__ + "img/49.99b3ad2b.png";